<template>
  <div class="mdc-textfield-container card-title-input">
    <div class="mdc-textfield" v-bind:class="inputValidationBindings">
      <input type="text"
             id="card-title-input"
             class="mdc-textfield__input"
             v-bind:value="text"
             v-on:input="onInput"
             required
             v-bind:placeholder="$t('card_details.card_meta.title_placeholder')">
    </div>
    <p class="mdc-textfield-helptext mdc-textfield-helptext--persistent mdc-textfield-helptext--validation-msg"
       role="alert"
       v-if="errors.has('text:required')">
      {{ $t('card_details.error.title_required') }}
    </p>
    <p class="mdc-textfield-helptext mdc-textfield-helptext--persistent mdc-textfield-helptext--validation-msg"
       role="alert"
       v-if="errors.has('text:max')">
      {{ $t('card_details.error.title_max_len') }}
    </p>
  </div>
</template>

<script>
  import { Validator } from 'vee-validate';

  export default {
    name: 'card-title-input',

    props: {
      modelValue: {
        type: String,
        default: '',
      },
    },

    validator: null,

    data() {
      return {
        errors: null,
      };
    },

    computed: {
      text() {
        return this.modelValue || '';
      },

      inputValidationBindings() {
        return {
          'mdc-textfield--invalid': this.errors.any(),
        };
      },
    },

    watch: {
      text(value) {
        this.validator.validate('text', value);
        this.$emit('has-error', this.errors.any());
      },
    },

    methods: {
      onInput(event) {
        this.$emit('input', event.target.value);
      },
    },

    created() {
      this.validator = new Validator({
        text: {
          required: true,
          max: 50,
        },
      });

      this.$set(this, 'errors', this.validator.errorBag);
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/CardTitleInput.vue